<template>
  <div class="confirmation__features-block d-flex flex-column" v-if="losedFeature.features.length">
      <div class="confirmation__features-block-title mb-1">{{losedFeature.key}}</div>
      <div v-for="(feature, index) in losedFeature.features" :key="index" class="confirmation__features-block-list d-flex flex-column">
        <div class="confirmation__features-block-list-item d-flex align-items-center justidy-content-center mb-1">
          <div class="confirmation__features-block-list-item-icon mr-1">
            <i class="icon icon-cancel text-light-high"></i>
          </div>
          <div class="confirmation__features-block-list-item-label">{{feature}}</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'LosedFeatureBlock',
  props: {
    losedFeature: Object,
  },
}
</script>

<style lang="scss" scoped>

</style>
